import AuditCriteriaSet, { auditCriterionVerificationAI } from 'models/auditCriteria';

// PLAN-CTI-081 (spec 7.2, 7.3): the import of a template's checklist and form into a generic criteria set.

export const templateCriteriaImportSourceChecklist = 'Checklist';
export const templateCriteriaImportSourceForm = 'Form';

export const templateCriteriaImportStatusNew = 'New';
export const templateCriteriaImportStatusDuplicateInSet = 'DuplicateInSet';
export const templateCriteriaImportStatusDuplicateInImport = 'DuplicateInImport';
export const templateCriteriaImportStatusNotConverted = 'NotConverted';

// why a source item is not converted (TemplateCriteriaSkipReasons on the server)
export const templateCriteriaImportReasonComputed = 'Computed';
export const templateCriteriaImportReasonAttachment = 'Attachment';
export const templateCriteriaImportReasonContext = 'Context';
export const templateCriteriaImportReasonRetired = 'Retired';
export const templateCriteriaImportReasonNoText = 'NoText';

export class TemplateCriteriaImportRequest {
  taskId: number;

  includeChecklist: boolean;

  includeForm: boolean;

  // auditCriterionVerification*: the verification of every added criterion, changeable per criterion afterwards
  verification: string;

  constructor() {
    this.taskId = 0;
    this.includeChecklist = true;
    this.includeForm = true;
    this.verification = auditCriterionVerificationAI;
  }
}

// One item of the template: the criterion it becomes, or why it is not added.
export class TemplateCriteriaImportRow {
  source: string;

  sourceIndex: number;

  sourceName: string;

  requirement: string;

  successCriteria: string;

  columnName: string;

  requiresComment: boolean;

  requiresEvidence: boolean;

  // templateCriteriaImportStatus*
  status: string;

  reason: string;

  existingCriterionKey: string;

  existingState: string;

  // a duplicate in the import: the source and the 1-based index of the item that wins
  duplicateOfSource: string;

  duplicateOfSourceIndex: number;

  constructor() {
    this.source = '';
    this.sourceIndex = 0;
    this.sourceName = '';
    this.requirement = '';
    this.successCriteria = '';
    this.columnName = '';
    this.requiresComment = false;
    this.requiresEvidence = false;
    this.status = '';
    this.reason = '';
    this.existingCriterionKey = '';
    this.existingState = '';
    this.duplicateOfSource = '';
    this.duplicateOfSourceIndex = 0;
  }
}

export class TemplateCriteriaImportPreview {
  templateName: string;

  templateTaskType: number;

  rows: TemplateCriteriaImportRow[];

  newCount: number;

  duplicateCount: number;

  notConvertedCount: number;

  constructor() {
    this.templateName = '';
    this.templateTaskType = 0;
    this.rows = [];
    this.newCount = 0;
    this.duplicateCount = 0;
    this.notConvertedCount = 0;
  }
}

export class TemplateCriteriaImportResult {
  preview: TemplateCriteriaImportPreview;

  set: AuditCriteriaSet | undefined;

  constructor() {
    this.preview = new TemplateCriteriaImportPreview();
    this.set = undefined;
  }
}
